export default {
  small: 639,
  medium: 1023,
  large: 1600,
  xlarge: 2048
};